import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import Venue from 'views/Venue';
import CreateVenue from 'views/Venue/CreateVenue';
import { Users } from 'views/User';
import { CreateUser } from 'views/User/CreateUser';
import Board from 'views/Board';
import ViewVenue from 'views/Venue/ViewVenue';
import ViewBoard from 'views/Board/ViewBoard';
import AppSettings from 'views/AppSettings';
import TransactionDetails from 'views/Transaction/TransactionDetail';
import BookingDetails from 'views/Bookings/BookingDetails';
// sample page routing
const Dashboard = Loadable(lazy(() => import('views/Dashboard')));
const Bookings = Loadable(lazy(() => import('views/Bookings')));
const Transaction = Loadable(lazy(() => import('views/Transaction')));

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        { path: '/dashboard', element: <Dashboard /> },
        { path: '/venue', element: <Venue /> },
        { path: '/venue/create', element: <CreateVenue /> },
        { path: '/venue/edit/:venueUuid', element: <CreateVenue /> },
        { path: '/venue/view/:venueUuid', element: <ViewVenue /> },
        { path: '/venue/view/:venueUuid/:bookingType/:bookingUuid', element: <BookingDetails /> },
        { path: '/board', element: <Board /> },
        { path: '/board/view/:boardUuid', element: <ViewBoard /> },
        { path: '/:bookingType/view/:boardUuid/booking/:bookingUuid', element: <BookingDetails /> },
        { path: '/bookings', element: <Bookings /> },
        { path: '/bookings/:bookingType/details/:bookingUuid', element: <BookingDetails /> },
        { path: '/transaction', element: <Transaction /> },
        { path: '/transaction/view/:bookingUuid', element: <TransactionDetails /> },
        { path: '/venue/view/:venueUuid/:bookingUuid', element: <TransactionDetails /> },
        { path: '/user', element: <Users /> },
        { path: '/user/create', element: <CreateUser /> },
        { path: '/user/edit/:userUuid', element: <CreateUser /> },
        { path: '/app-settings', element: <AppSettings /> }
    ]
};

export default MainRoutes;
